<template>
  <div
    :class="cardAlignment"
    class="donate-page"
  >
    <DonateCard
      v-if="!loading"
      :page="donationPage"
    />

    <div
      class="preloader"
      v-if="loading"
    >
    <img
            src="@/assets/new-adra-logo.png"
            class="object-contain w-64 h-auto mb-8" >
      <pulse-loader
        :loading="loading"
        color="#007B5F"
        class=""
      />
    </div>
  </div>
</template>

<script>
import { initAnalytics } from '../social'
import DonateCard from '@/components/DonatePage/DonateCard'
import PageService from '../api/PageService'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  name: 'DonatePage',

  components: {
    DonateCard,
    PulseLoader
  },

  props: {
    code: {
      type: String,
      default: 'US'
    },

    slug: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      loading: true,
      donationPage: {
        contents: {}
      }
    }
  },

  computed: {
    cardAlignment() {
      if (
        !this.donationPage.contents ||
        this.donationPage.contents.form_alignment === 'left'
      ) {
        return 'donate-page__start'
      }

      if (this.donationPage.contents.form_alignment === 'center') {
        return 'donate-page__center'
      }
      return 'donate-page__end'
    }
  },

  async created() {
    let result

    if (this.slug) {
      result = await PageService.getDonationPageBySlug(
        this.code.toUpperCase(),
        this.slug
      )
    } else {
      result = await PageService.getDefaultPageByOrganization()
    }
    this.initializePage(result.data.data)

    initAnalytics({
      google: this.donationPage.google_analytics_id
    })

    this.$gtm.trackEvent({
      category: 'ADRA',
      action: 'visit',
      label: 'DonationPageSlug',
      value: this.donationPage.slug
    })
  },

  methods: {
    initializePage(data) {
      this.donationPage = data
      this.donationPage.contents = JSON.parse(data.contents)

      const { amount_values } = this.donationPage.contents
      this.donationPage.contents.amount_values =
        typeof amount_values === 'string'
          ? JSON.parse(amount_values)
          : amount_values

      this.loading = false
      let bodyElement = document.body
      const backgroundURL = this.donationPage.background_image.replace(
        /^http:\/\//i,
        'https://'
      )
      bodyElement.style.background = `#322d2b url('${backgroundURL}') no-repeat center top`
      bodyElement.style.backgroundAttachment = 'fixed'
      bodyElement.style.backgroundSize = 'cover'
    }
  }
}
</script>

<style scoped>
.preloader {
  @apply h-screen w-full z-50 fixed left-0 top-0  flex flex-col items-center justify-center;
  background: rgba(23, 22, 22, 0.5);
  top: 0;
  transition: opacity 0.3s linear;
}
</style>
